import { I18n } from '@calendly/i18n'

import { Summary } from './summary'
import { AccordionPanel } from '../../../components/accordion'
import { Description } from '../../components/description'

export const DescriptionPanel = ({ isLocked, ...props }) => (
  <AccordionPanel
    titleId="description-label"
    title={I18n.t('publisher.event_type_editor.sections.more_options.description.title')}
    subheader={<Summary isLocked={isLocked} />}
    {...props}
  >
    <Description isLocked={isLocked} />
  </AccordionPanel>
)
